"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var useAppContext_1 = require("../../../common/react/useAppContext");
var ReserveOnlineStyles_1 = require("./ReserveOnlineStyles");
var ReserveOnlineText = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var style = ReserveOnlineStyles_1.default();
    var deal = useAppContext_1.default().deal;
    var intl = react_intl_1.useIntl();
    var latestTransaction = (_c = (_a = deal) === null || _a === void 0 ? void 0 : _a.payment.transactions[((_b = deal) === null || _b === void 0 ? void 0 : _b.payment.transactions.length) - 1], (_c !== null && _c !== void 0 ? _c : null));
    var latestTransactionId = (_e = (_d = latestTransaction) === null || _d === void 0 ? void 0 : _d.externalId, (_e !== null && _e !== void 0 ? _e : null));
    var latestTransactionDate = ((_f = latestTransaction) === null || _f === void 0 ? void 0 : _f.transactionDate) ? ((_g = latestTransaction) === null || _g === void 0 ? void 0 : _g.transactionDate.split('+')[0]) + 'Z'
        : new Date().toISOString();
    var latestTransactionDateLabel = (_h = date_fns_1.format(date_fns_1.parseISO(latestTransactionDate), 'dd/MMM/yyyy hh:mm aa'), (_h !== null && _h !== void 0 ? _h : null));
    return (<>
      {latestTransaction && (<core_1.Typography component="h2" variant="body1" data-test="text:confirmation:transactiondate" className={style.paragraph}>
          <Translation_1.default id="payment.cardDetails.dateTimeOfPayment"/>
          {(latestTransactionDateLabel !== null && latestTransactionDateLabel !== void 0 ? latestTransactionDateLabel : '')}
        </core_1.Typography>)}
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:paragraph1" className={style.paragraph}>
        <Translation_1.default id="confirmation.content.dealership.dealerContact"/>
      </core_1.Typography>
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:paragraph2" className={style.paragraph}>
        <Translation_1.default id="confirmation.content.dealership.referenceNumber" values={{
        orderId: (_j = deal) === null || _j === void 0 ? void 0 : _j.order,
    }}/>
      </core_1.Typography>
      {latestTransaction && (<core_1.Typography component="h2" variant="body1" data-test="text:confirmation:transactionid" className={style.paragraph}>
          <Translation_1.default id="payment.cardDetails.transactionID"/>
          {latestTransactionId}
        </core_1.Typography>)}
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:paragraph3" className={style.paragraph}>
        <Translation_1.default id="confirmation.content.checkoutReserveOnline.content.1" values={{
        phoneNumber: (<a data-test="text:reserveOnline:phoneNumber" href={"tel:" + intl.formatMessage({ id: 'label.getInTouch.phoneNumber' })}>
                <Translation_1.default id="label.getInTouch.phoneNumber"/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = ReserveOnlineText;
